/* lua.js generated code 0.3.0 */

var [LoadingPanel, LoadingPanelEvent] = unpack(require("clover/panel/LoadingPanel"))
require('clover/utils/ObjectPool')

LoadingPanelLogic = xClass("LoadingPanelLogic")
var instance = null
LoadingPanelLogic.getInstance = function () {
    var self = this
    if (!instance) {
        instance = LoadingPanelLogic.new()
    }
    return instance
}
LoadingPanelLogic.prototype.ctor = function () {
    var self = this
    self.registerStack = table()
    self.idCounter = 0
    self.loadingPanel = null
    self.eventHandler = null
    this.pool = ObjectPool.getHomeInstance()
    this.pool.preload('LoadingPanel', () => LoadingPanel.create(), 0)
}
LoadingPanelLogic.prototype.add = function (text, closeCallback) {
    var self = this
    self.idCounter = self.idCounter + 1
    table.insert(self.registerStack, 1, table(
        [1, "id", self.idCounter],
        [1, "text", text],
        [1, "closeCallback", closeCallback]
    ))
    if ($len(self.registerStack) === 1) {
        self.loadingPanel = this.pool.get('LoadingPanel')
        self.loadingPanel.show()
    }
    self.loadingPanel.setCloseEnabled(closeCallback != null)
    self.loadingPanel.setString(text)
    self.loadingPanel.removeEventListener(self.eventHandler)
    let useless
    [useless, self.eventHandler] = self.loadingPanel.on(LoadingPanelEvent.Close, function () {
        if (closeCallback) {
            closeCallback()
        }
    })
    return self.idCounter
}
LoadingPanelLogic.prototype.remove = function (id) {
    var self = this
    for (var i = 1, v = self.registerStack[1]; v; i++, v = self.registerStack[i]) {
        if (v.id === id) {
            table.remove(self.registerStack, i)
            if ($len(self.registerStack) > 0 && i === 1) {
                self.loadingPanel.setCloseEnabled(self.registerStack[1].closeCallback != null)
                self.loadingPanel.setString(self.registerStack[1].text)
                self.loadingPanel.removeEventListener(self.eventHandler)
                var useless
                [useless, self.eventHandler] = self.loadingPanel.on(LoadingPanelEvent.Close, function () {
                    if (self.registerStack[1].closeCallback) {
                        self.registerStack[1].closeCallback()
                    }
                })
            } else if ($len(self.registerStack) <= 0) {
                self.loadingPanel.remove()
                this.pool.collect('LoadingPanel', self.loadingPanel, false)
                self.loadingPanel = null
            }
            return 
        }
    }
}
LoadingPanelLogic.prototype.loading = function () {
    var self = this
    return $len(self.registerStack) > 0
}
